import { Model } from '@vuex-orm/core'

export default class StudentCourse extends Model {
    
    static entity = 'student_course'
  
    static primaryKey = ['student_id', 'course_id']
  
    static fields () {
        return {
            student_id: this.attr(null),
            course_id: this.attr(null)
        }
    }
}